import gql from 'graphql-tag';
import { apollo } from 'src/features';
import { parseConfig } from 'api/getChannels';

const query = gql`
query Activity($id: ID!) {
  activity(id: $id) {
    id
    channel {
      id
      config
    }
  }
}`;

function getChannelConfigByActivity(id) {
  return apollo.client.query({
    variables: { id },
    query,
    fetchPolicy: 'network-only',
  }).then((res) => parseConfig(res.data.activity.channel.config));
}

export default getChannelConfigByActivity;
